export default __webpack_public_path__ + "static/media/clairo.d31b6e70.jpeg";